import PageHeader from "@/components/PageHeader";
import StatusBadge from "@/components/StatusBadge";
import { Card } from "@/components/ui/card";
import { workflowStages } from "@/data/mockData";
import { Check } from "lucide-react";

export default function Workflow() {
  return (
    <div className="space-y-8" data-testid="workflow-page">
      <PageHeader
        title="Business Workflow"
        subtitle="A simple, universal workflow that fits ANY business."
      />

      {/* Horizontal stepper */}
      <div className="hidden md:block">
        <div className="flex items-start gap-0 relative">
          {workflowStages.map((s, i) => {
            const done = s.status === "Completed";
            const active = s.status === "In Progress";
            return (
              <div key={s.id} className="flex-1 flex flex-col items-center relative">
                {/* Connector line */}
                {i < workflowStages.length - 1 && (
                  <div
                    className={`absolute top-5 left-1/2 w-full h-0.5 ${
                      done ? "bg-primary" : "bg-slate-200 dark:bg-slate-700"
                    }`}
                  />
                )}
                <div
                  className={`relative z-10 h-10 w-10 rounded-full flex items-center justify-center text-sm font-semibold border-2 ${
                    done
                      ? "bg-primary border-primary text-white"
                      : active
                      ? "bg-white dark:bg-slate-900 border-slate-900 text-slate-900 dark:text-slate-100"
                      : "bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800 text-slate-400 dark:text-slate-500"
                  }`}
                >
                  {done ? <Check className="h-4 w-4" /> : s.number}
                </div>
                <div className="mt-3 text-center px-2">
                  <div className="text-sm font-semibold text-slate-900 dark:text-slate-100">{s.title}</div>
                  <div className="mt-1">
                    <StatusBadge status={s.status} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Stage cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 stagger" data-testid="workflow-stages">
        {workflowStages.map((s, idx) => {
          const done = s.status === "Completed";
          const active = s.status === "In Progress";
          return (
            <Card
              key={s.id}
              data-testid={`workflow-stage-${s.number}`}
              style={{ ["--i"]: idx }}
              className={`p-6 border rounded-xl bg-white dark:bg-slate-900 elev-1 lift ${
                active ? "border-primary/40 ring-1 ring-primary/20" : "border-slate-200 dark:border-slate-800"
              }`}
            >
              <div className="flex items-center justify-between">
                <div
                  className={`h-8 w-8 rounded-lg flex items-center justify-center text-xs font-bold ${
                    done
                      ? "bg-primary text-primary-foreground"
                      : active
                      ? "bg-primary/10 dark:bg-primary/15 text-primary border border-primary/30"
                      : "bg-slate-50 dark:bg-slate-900 text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-slate-800"
                  }`}
                >
                  {s.number}
                </div>
                <StatusBadge status={s.status} />
              </div>
              <h3 className="mt-4 font-display text-lg font-semibold text-slate-900 dark:text-slate-100">
                {s.title}
              </h3>
              <p className="mt-1 text-sm text-slate-500 dark:text-slate-400 leading-relaxed">
                {s.description}
              </p>
              <ul className="mt-4 space-y-1.5 pt-4 border-t border-slate-100 dark:border-slate-800">
                {s.items.map((item, i) => (
                  <li key={i} className="text-xs text-slate-600 dark:text-slate-300 flex items-center gap-2">
                    <span className="h-1 w-1 rounded-full bg-slate-400" />
                    {item}
                  </li>
                ))}
              </ul>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
